import React, { Component } from 'react'
import { RouterView } from '@merchant-backend/common-components'
import styles from './style.module.less'
import { observer } from 'mobx-react'
import { PATH_ZTB, TIAN_GONG_ZTB } from '../constant'
import { Link } from 'react-router'
import { Modal } from 'hljd'
import Api from '@api/jobs'

@observer
export default class extends Component {
  render() {
    return (
      <RouterView
        title="产品介绍"
        header={[<Link to={PATH_ZTB}>智推宝</Link>, '产品介绍']}
        bodyStyle={{ padding: 0 }}
        footer={
          <div style={{ position: 'relative' }}>
            <img src="https://qnm.hunliji.com/FnorKDvMtxNyu-Td5BNTbU162A51" />

            <img
              src="https://qnm.hunliji.com/FhsYXcDXXJSc5Uygw2s1q2fywb73"
              className="center"
              style={{ cursor: 'pointer' }}
              onClick={async () => {
                const { success } = await Api.addCpmJob({
                  job_type: TIAN_GONG_ZTB
                })
                if (success) {
                  Modal.success({
                    title: '申请提交成功',
                    content: '稍后会有专属客户经理与您电话联系'
                  })
                }
              }}
            />
          </div>
        }
      >
        <div className={styles.imgs}>
          <img src="https://qnm.hunliji.com/FnqoUutYdMf335ppQ7V9Y6x_pYRR" />
          <img src="https://qnm.hunliji.com/FkmuCxXBIVn3IbyaeRLYL91OWmrq" />
          <img src="https://qnm.hunliji.com/Fpw81Ny9P9lckTnRy59or6mHSNor" />
          <img src="https://qnm.hunliji.com/Fs9dL2KU67R19A1KThJAPG9YdRQ2" />
          <img src="https://qnm.hunliji.com/Fkji3IxVoLmn9LONITqlOoqeMzee" />
          <img src="https://qnm.hunliji.com/FqAZ4Tml0v21EQGR3I2HxkHgc0XU" />
        </div>
      </RouterView>
    )
  }
}
